import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import {
  Panel,
  Button,
  Message,
  Grid,
  Row,
  Col,
  Icon,
  ControlLabel,
  Cascader,
  Input,
  Checkbox,
} from 'rsuite'
import WithdrawalByReviewerEditTable from './WithdrawalByReviewerEditTable'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { useForm, Controller } from 'react-hook-form'
import { isValidators, isRequired } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import { startLoading, doneLoading } from '../../utils/loading'
import {
  downloadPaymentByReviewer,
  saveRequestMultipleProject,
  saveReviewerPaymentApprover,
} from '../../redux/actions/withdrawReviewPayment'
import NumberFormat from 'react-number-format'
import notification from '../../utils/notification'
import { downloadFile } from '../../utils/fileUtil'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import {
  CONFIRM_MSG,
  DEFAULT_ERR_MSG,
  PLEASE_CONFIRM_MSG,
  SAVE,
  SAVE_APPROVE_SUCCESS_MSG,
  SAVE_DRAFT_MSG,
  SAVE_DRAFT_SUCCESS_MSG,
  SAVE_SUCCESS_MSG,
} from '../../constants/msgText'
import InputForm from '../../components/forms/input/InputForm'
import { getValueFromOptions } from '../../utils/dataUtil'
import ApproverList from '../../components/modal/ApproverListModal/ApproverList'
import CancelApprovalList from '../../components/modal/ApproverListModal/CancelApprovalList'
import FetchNewApprover from '../../components/modal/ApproverListModal/FetchNewApprover'

export default function WithdrawalByReviewerPanel({
  schema,
  projectVersionId,
  onCancelShowTable,
  isApprove,
  status,
  approveSuccess = () => {},
  onSuccess,
  onButtonSuccess = () => {},
  reviewerData,
  statusOptions,
  statusOptionsForApprover,
}) {
  const { handleSubmit, errors, control, setValue, watch, register, getValues, clearErrors } =
    useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [formSchema, setFormSchema] = useState()
  const [isShowConfirmSendApprove, setIsShowConfirmSendApprove] = useState(false)
  const [isShowConfirmApprove, setIsShowConfirmApprove] = useState(false)
  const [isShowConfirmNotApprove, setIsShowConfirmNotApprove] = useState(false)
  const [isShowConfirmSaveDraft, setIsShowConfirmSaveDraft] = useState(false)
  const [requestBody, setRequestBody] = useState()
  const [masterCost, setMasterCost] = useState(0)
  const [masterPlan, setMasterPlan] = useState()
  const [dataList, setDataList] = useState()
  const [statusCode, setStatusCode] = useState(status)
  const [groupId, setGroupId] = useState()
  const [disabledForm, setDisabledForm] = useState(false)
  const [isAlreadyWithdraw, setIsAlreadyWithdraw] = useState(false)
  const [workPlanCodeVal, setWorkPlanCodeVal] = useState()
  const [budgetVal, setBudgetVal] = useState()

  const dispatch = useDispatch()

  useEffect(() => {
    setFormSchema(schema)
    if (
      schema?.projectData?.bankAccountNumber &&
      schema?.projectData?.bankAccountNumber == 'ไม่พบข้อมูลธนาคาร'
    ) {
      setDisabledForm(true)
    } else {
      setDisabledForm(false)
    }

    if (schema?.projectBudgetPlan?.masterBudgetPlan?.value) {
      setWorkPlanCodeVal(schema?.projectBudgetPlan?.masterBudgetPlan?.value)
      console.log(schema?.projectBudgetPlan?.masterBudgetPlan?.value)
    }

    if (schema?.projectData?.values?.length > 0) {
      var total = getTotalSummary(schema?.projectData?.values)
      setBudgetVal(total)
      console.log(total)
    }

    // resetShowTable()
  }, [schema])

  useEffect(() => {
    if (schema && status) {
      handleSetDataList(schema, status)
      setStatusCode(status)
    }
  }, [schema, status])

  useEffect(() => {
    if (formSchema?.alreadyWithdraw && !formSchema?.budget?.approveButtonText) {
      setIsAlreadyWithdraw(formSchema.alreadyWithdraw.alreadyWithdraw.value)
    }
  }, [formSchema])

  // const resetShowTable = () => {
  //   setIsError(false)
  //   setValue('masterPlan', '')
  //   setValue('masterCost', '')
  //   setMasterCost(0)

  //   clearErrors('masterPlan')
  // }

  const handleSetDataList = (schema, status) => {
    if (status == 2 || status == 3) {
      let concatData = []
      schema.projectData?.waitAndApproveValues?.forEach((element, index) => {
        element.values.forEach((item) => {
          let _item = {
            ...item,
            numberOfSequence: element.numberOfSequence || 0,
          }
          concatData.push(_item)
        })
      })
      setDataList(concatData)
    } else {
      setDataList(schema.projectData?.values)
      if (schema.projectData?.values?.length > 0) {
        setMasterPlan(schema.projectData?.values[0].budgetPlanCode)
        setValue('masterPlan', schema.projectData?.values[0].budgetPlanCode)
      }
    }
  }

  const handleCallApiSendApprove = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    setIsShowConfirmSendApprove(false)
    try {
      const response = await saveRequestMultipleProject(requestBody)
      if (response.success) {
        setFormSchema(response.model.forms)

        if (response.model?.responseValidate?.isSuccess) {
          onSuccess(
            requestBody.status,
            response?.model?.forms?.budget?.reviewerData[0]?.projectReviewerPaymentId || null
          )
          handleSetDataList(response.model.forms, requestBody.status)
          setStatusCode(requestBody.status)

          notification.open('success', {
            title: SAVE_SUCCESS_MSG,
            duration: 10000,
          })
        } else {
          setIsError(response.model?.responseValidate?.message || DEFAULT_ERR_MSG)
        }
      }
    } catch (e) {
      setIsError(
        e?.response?.data?.errors?.message || e?.response?.data?.errorMessage || DEFAULT_ERR_MSG
      )
    }
    setIsShowConfirmSendApprove(false)
    doneLoading()
    setIsLoading(false)
  }

  const handleCallApiSaveDraft = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    setIsShowConfirmSaveDraft(false)
    try {
      const response = await saveRequestMultipleProject(requestBody)
      if (response.success) {
        setFormSchema(response.model.forms)

        if (response.model?.responseValidate?.isSuccess) {
          onSuccess(
            1,
            response?.model?.forms?.budget?.reviewerData[0]?.projectReviewerPaymentId || null
          )
          handleSetDataList(response.model.forms, 1)
          setStatusCode(1)

          notification.open('success', {
            title: SAVE_DRAFT_SUCCESS_MSG,
            duration: 10000,
          })
        } else {
          setIsError(response.model?.responseValidate?.message || DEFAULT_ERR_MSG)
        }
      }
    } catch (e) {
      setIsError(
        e?.response?.data?.errors?.message || e?.response?.data?.errorMessage || DEFAULT_ERR_MSG
      )
    }
    setIsShowConfirmSaveDraft(false)
    doneLoading()
    setIsLoading(false)
  }

  const handleCallApiApprove = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    setIsShowConfirmApprove(false)
    setIsShowConfirmNotApprove(false)
    try {
      const response = await saveReviewerPaymentApprover(requestBody)
      if (response.success) {
        setFormSchema(response.model.forms)
        approveSuccess(requestBody.status)
        handleSetDataList(response.model.forms, requestBody.status)
        setStatusCode(requestBody.status)

        if (requestBody.status == 4) {
          onCancelShowTable()
        }

        notification.open('success', {
          title: SAVE_APPROVE_SUCCESS_MSG,
          duration: 10000,
        })
      }
    } catch (e) {
      console.log('WithdrawalByReviewerPanel : ', e)
      setIsError(
        e?.response?.data?.errors?.message || e?.response?.data?.errorMessage || DEFAULT_ERR_MSG
      )
    }
    setIsShowConfirmApprove(false)
    setIsShowConfirmNotApprove(false)
    doneLoading()
    setIsLoading(false)
  }

  const handleOnConfirmSendApprove = (data) => {
    console.log('data send approve', data)
    setIsError(false)

    const _projectData = formSchema?.projectData?.values.map((item) => {
      let _data = {
        // ...item,
        // id: item.id,
        // reviewerName: item.reviewerName,
        // cost: data[`cost_${item.id}`],
        // budgetPlanCode: data[`budgetPlanCode_${item.id}`],
        projectCode: item.projectCode,
        //workPlanCode: data[`budgetPlanCode_${item.id}`],
        workPlanCode: masterPlan,
        amount: data[`cost_${item.id}`],
      }
      return _data
    })

    let status = '2'
    let note = ''

    if (isAlreadyWithdraw) {
      status = '10'
      note = data.alreadyWithdrawNote
    }

    const projectRequests = _projectData.filter((item) => !item.amount == 0 || status == '10')

    if (projectRequests.length == 0) {
      setIsError('กรุณากรอกจำนวนเงินที่ต้องการขอเบิก อย่างน้อย 1 โครงการ')
      return
    }

    const request = {
      projectReviewerPaymentId: reviewerData.id,
      reviewerId: reviewerData.personId,
      reviewerName: reviewerData.firstName + ' ' + reviewerData.lastName,
      projectRequests: projectRequests,
      status: status,
      note: note,
    }

    console.log('request', request)

    setRequestBody(request)
    setIsShowConfirmSendApprove(true)
  }

  const handleOnSaveDraft = (data) => {
    console.log('data send approve', data)
    setIsError(false)

    const _projectData = formSchema?.projectData?.values.map((item) => {
      let _data = {
        // ...item,
        // id: item.id,
        // reviewerName: item.reviewerName,
        // cost: data[`cost_${item.id}`],
        // budgetPlanCode: data[`budgetPlanCode_${item.id}`],
        projectCode: item.projectCode,
        //workPlanCode: data[`budgetPlanCode_${item.id}`],
        workPlanCode: masterPlan,
        amount: data[`cost_${item.id}`],
      }
      return _data
    })

    const request = {
      projectReviewerPaymentId: reviewerData.id,
      reviewerId: reviewerData.personId,
      reviewerName: reviewerData.firstName + ' ' + reviewerData.lastName,
      projectRequests: _projectData,
      status: 1,
    }

    console.log('request', request)
    setRequestBody(request)
    setIsShowConfirmSaveDraft(true)
  }

  const handleOnConfirmApprove = (data, approve) => {
    console.log('data approve', data)

    const projectReviewerPaymentId = dataList[0].projectPaymentReviewerId

    let request = {
      requestNote: data.requestNote,
      status: approve ? 3 : 4,
      projectReviewerPaymentId: projectReviewerPaymentId,
      //values: dataList,
    }

    console.log('request body', request)
    setRequestBody(request)

    if (approve) {
      setIsShowConfirmApprove(true)
    } else {
      setIsShowConfirmNotApprove(true)
    }
  }

  const getMasterBudgetPlanLabel = (masterBudgetPlan) => {
    const planCode = masterBudgetPlan.value
    let planLabel = ''
    let workPlanLabel = ''
    let actionPlanLabel = ''
    if (planCode) {
      masterBudgetPlan?.items?.forEach((planItem) => {
        if (planItem.value == planCode.substring(0, 2)) {
          planLabel = planItem.label
          planItem?.children?.forEach((workPlanItem) => {
            if (workPlanItem.value == planCode.substring(0, 6)) {
              workPlanLabel = workPlanItem.label
              workPlanItem?.children?.forEach((actionPlanItem) => {
                if (actionPlanItem.value == planCode) {
                  actionPlanLabel = actionPlanItem.label
                }
              })
            }
          })
        }
      })
      //console.log('planCodeLabel', planCodeLabel)
      return `${planCode} ( ${planLabel} / ${workPlanLabel} / ${actionPlanLabel} )`
    } else {
      return
    }
  }

  const onClickApplyToAll = () => {
    formSchema.projectData?.values.forEach((item) => {
      console.log('item', item)
      setValue(`${'cost'}_${item.id}`, masterCost)
      setValue(`${'budgetPlanCode'}_${item.id}`, masterPlan)
    })
  }

  // const getStatusLabel = (status) => {
  //   switch (status) {
  //     case 1:
  //       return 'รอเบิกจ่าย'
  //       break
  //     case 2:
  //       return 'รออนุมัติ'
  //       break
  //     case 3:
  //       return 'อนุมัติ'
  //       break
  //     case 4:
  //       return 'ไม่อนุมัติ'
  //       break
  //     default:
  //       break
  //   }
  // }

  const getOptions = () => {
    let _data = []
    if (formSchema.projectData?.waitAndApproveValues?.length > 0) {
      formSchema.projectData?.waitAndApproveValues.forEach((item) => {
        let _item = {
          label: 'ชุดที่ ' + item.numberOfSequence,
          value: item.projectPaymentReviewGroupId,
        }
        _data.push(_item)
      })
    }
    return _data
  }

  const handleOnChangeGroup = (value) => {
    if (!value) {
      handleSetDataList(formSchema, statusCode)
      setGroupId()
      return
    }

    if (formSchema.projectData?.waitAndApproveValues?.length > 0) {
      let newData = []
      formSchema.projectData?.waitAndApproveValues.forEach((element) => {
        if (element.projectPaymentReviewGroupId == value) {
          setGroupId(element.projectPaymentReviewGroupId)
          element.values.forEach((item) => {
            let _item = {
              ...item,
              numberOfSequence: element.numberOfSequence || 0,
            }
            newData.push(_item)
          })
        }
      })
      setDataList(newData)
    }
  }

  const onDownload = async (groupId) => {
    startLoading()
    try {
      const file = await downloadPaymentByReviewer(groupId)
      let fileName = 'ใบเบิกจ่าย ' + formSchema.header
      downloadFile(file, fileName)
    } catch (err) {
      notification.open('error', {
        title: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
      })
    }
    doneLoading()
  }

  const getTotalSummary = (_tableData) => {
    return _tableData.reduce((pre, cur) => {
      if (cur.cost && !cur.isTotal) {
        return pre + cur.cost
      }
      return pre
    }, 0)
  }

  return (
    <>
      {formSchema && (
        <Panel header={formSchema.header} collapsible bordered defaultExpanded>
          <div style={{ marginBottom: 10 }}>
            <p>
              <strong>{`สถานะ : ${getValueFromOptions(statusOptions, statusCode)}`}</strong>
            </p>
          </div>

          {!formSchema.projectData?.readOnly && !isApprove ? (
            <Row style={{ marginBottom: 10 }}>
              <Col xs={24} sm={24} md={24} lg={18}>
                <ControlLabel
                  className={classNames(
                    isRequired(formSchema.projectBudgetPlan?.masterBudgetPlan?.validators) &&
                      'required'
                  )}
                >
                  {formSchema.projectBudgetPlan?.masterBudgetPlan?.label}
                </ControlLabel>
                <ErrorMessage error={errors.masterPlan} />
                <Controller
                  name={'masterPlan'}
                  control={control}
                  defaultValue={masterPlan}
                  value={masterPlan}
                  rules={isValidators(formSchema.projectBudgetPlan?.masterBudgetPlan.validators)}
                  render={(props) => {
                    return (
                      <Cascader
                        size="lg"
                        block
                        menuWidth={220}
                        data={formSchema.projectBudgetPlan?.masterBudgetPlan.items}
                        value={props.value}
                        onChange={(value) => {
                          props.onChange(value)
                          setValue('subBudgetPlan', null)
                          setMasterPlan(value)
                          setWorkPlanCodeVal(value)
                        }}
                        placeholder={formSchema.projectBudgetPlan?.masterBudgetPlan?.label}
                      ></Cascader>
                    )
                  }}
                />
              </Col>
              <Col xs={24} sm={24} md={24} lg={6}>
                <ControlLabel>ค่าทบทวนโครงการ</ControlLabel>
                <Controller
                  name={`masterCost`}
                  control={control}
                  defaultValue={masterCost}
                  //rules={{ required: 'กรุณากรอกจำนวนเงิน' }}
                  render={(props) => {
                    return (
                      <NumberFormat
                        className={classNames('rs-input', errors[`masterCost`] && 'is-error')}
                        thousandSeparator={true}
                        value={props.value}
                        onValueChange={(value) => {
                          props.onChange(value.floatValue)
                          setMasterCost(value.floatValue)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col style={{ marginTop: 10, textAlign: 'right' }} xs={24} sm={24} md={24} lg={24}>
                <Button
                  style={{ width: 'auto', marginRight: 5 }}
                  color="rgb(45, 168, 136)"
                  appearance="primary"
                  onClick={() => onClickApplyToAll()}
                  disabled={isLoading || disabledForm}
                >
                  จ่ายเท่ากันทุกโครงการ
                </Button>
              </Col>
            </Row>
          ) : (
            <div style={{ marginBottom: 10 }}>
              <p>
                {formSchema.projectBudgetPlan?.masterBudgetPlan.label}
                {' : '}
                <span>
                  {getMasterBudgetPlanLabel(formSchema.projectBudgetPlan?.masterBudgetPlan)}
                </span>
              </p>
            </div>
          )}

          {formSchema?.projectData && (
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <span style={{ marginRight: 20 }}>ธนาคาร : {formSchema.projectData?.bankName}</span>
                <span>เลขที่บัญชี : {formSchema.projectData?.bankAccountNumber}</span>
              </Col>
            </Row>
          )}

          {/* {(statusCode == 2 || statusCode == 3) && (
            <div>
              <Row>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <ControlLabel>ชุดโครงการที่ส่งพิจารณา : </ControlLabel>
                  <SelectPicker
                    data={getOptions()}
                    //value={}
                    onChange={(value) => {
                      handleOnChangeGroup(value)
                    }}
                    placeholder="เลือกชุดโครงการที่ส่งพิจารณา"
                    style={{ width: 300 }}
                  />
                </Col>
              </Row>
            </div>
          )}

          {(statusCode == 2 || statusCode == 3) && (
            <Row>
              <div style={{ float: 'right', marginBottom: 10 }}>
                <IconButton
                  appearance="ghost"
                  icon={<Icon icon="download" className="bt-gost-icon-radius" />}
                  onClick={() => {
                    onDownload(groupId)
                  }}
                  disabled={!groupId}
                >
                  ดาวน์โหลดใบเบิก
                </IconButton>
              </div>
            </Row>
          )} */}

          <div style={{ marginBottom: 10 }}>
            <WithdrawalByReviewerEditTable
              data={dataList}
              readOnly={formSchema.projectData?.readOnly}
              register={register}
              errors={errors}
              control={control}
              setValue={setValue}
              getValues={getValues}
              projectBudgetPlan={formSchema.projectBudgetPlan}
              isApprove={isApprove}
              statusCode={statusCode}
              disabledForm={disabledForm}
              onChangeTotal={(total) => setBudgetVal(total)}
            />
          </div>

          {formSchema?.projectData?.requestNote && isApprove && statusCode === 2 && (
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <ControlLabel
                  className={classNames(
                    isRequired(formSchema.projectData.requestNote.validators) && 'required'
                  )}
                >
                  {formSchema.projectData.requestNote.label}
                </ControlLabel>
                <ErrorMessage error={errors.requestNote} />
                <Input
                  placeholder={formSchema.projectData.requestNote.hint}
                  defaultValue={formSchema.projectData.requestNote.value}
                  name={formSchema.projectData.requestNote.name}
                  componentClass="textarea"
                  inputRef={register(isValidators(formSchema.projectData.requestNote.validators))}
                />
              </Col>
            </Row>
          )}

          {formSchema?.alreadyWithdraw && !isApprove && (
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Checkbox
                  disabled={disabledForm || formSchema.alreadyWithdraw?.readOnly}
                  name={formSchema.alreadyWithdraw.alreadyWithdraw.name}
                  checked={isAlreadyWithdraw}
                  onChange={(value, checked) => {
                    setIsAlreadyWithdraw(checked)
                  }}
                >
                  {formSchema.alreadyWithdraw.alreadyWithdraw.label}
                </Checkbox>
              </Col>
              {isAlreadyWithdraw && (
                <Col xs={24} sm={24} md={24} lg={24}>
                  <InputForm
                    disabled={disabledForm || formSchema.alreadyWithdraw?.readOnly}
                    schema={formSchema.alreadyWithdraw.alreadyWithdrawNote}
                    rows={3}
                    componentClass="textarea"
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>
              )}
            </Row>
          )}

          <Grid fluid>
            <Row>
              {disabledForm && (
                <Message
                  showIcon
                  type="error"
                  description={'ไม่มีเลขที่บัญชีส่งจ่าย กรุณาติดต่อ ผู้ที่เกี่ยวข้องเพื่อตรวจสอบ'}
                />
              )}
              {isError && (
                <Col style={{ marginTop: 10 }} xs={24} sm={24} md={24} lg={24}>
                  <Message showIcon type="error" description={isError} />
                </Col>
              )}
              <Col
                style={{ marginTop: 20, marginBottom: 20, textAlign: 'right' }}
                xs={24}
                sm={24}
                md={24}
                lg={24}
              >
                {isApprove && statusCode === 2 ? (
                  <Row>
                    {formSchema?.projectData?.approveButtonText && (
                      <Button
                        style={{ width: 'auto', marginRight: 5 }}
                        color="rgb(45, 168, 136)"
                        appearance="primary"
                        onClick={handleSubmit((e) => handleOnConfirmApprove(e, true))}
                        disabled={isLoading}
                      >
                        {formSchema?.projectData?.approveButtonText}
                      </Button>
                    )}
                    {formSchema?.projectData?.notApproveButtonText && (
                      <Button
                        style={{ width: 'auto' }}
                        appearance="ghost"
                        onClick={handleSubmit((e) => handleOnConfirmApprove(e, false))}
                        disabled={isLoading}
                      >
                        {formSchema?.projectData?.notApproveButtonText}
                      </Button>
                    )}
                  </Row>
                ) : (
                  formSchema?.projectData?.sendApproveButtonText &&
                  !formSchema.projectData?.readOnly && (
                    <Row>
                      {/* <Button
                        style={{ width: 'auto', marginBottom: 10, marginRight: 5 }}
                        color="rgb(45, 168, 136)"
                        appearance="primary"
                        onClick={handleSubmit(handleOnSaveDraft)}
                        icon={<Icon appearance="ghost" icon="edit" />}
                        disabled={isLoading || disabledForm}
                      >
                        {'บันทึกร่าง'}
                      </Button> */}

                      {!isAlreadyWithdraw ? (
                        <ApproverList
                          approveType={12}
                          disabled={isLoading || disabledForm}
                          projectversionId={formSchema?.projectData?.values[0]?.id}
                          style={{ marginLeft: 10, marginBottom: 10 }}
                          buttontext={
                            'ตรวจสอบสายอนุมัติและ' + formSchema?.projectData?.sendApproveButtonText
                          }
                          workPlanCode={workPlanCodeVal}
                          budget={budgetVal}
                          isLoading={isLoading}
                          fetchButton={(disabled) =>
                            <Button
                              style={{ width: 'auto', marginBottom: 10 }}
                              color="rgb(45, 168, 136)"
                              appearance="primary"
                              onClick={handleSubmit(handleOnConfirmSendApprove)}
                              icon={<Icon appearance="ghost" icon="edit" />}
                              disabled={disabled || isLoading || disabledForm}
                            >
                              {formSchema?.projectData?.sendApproveButtonText}
                            </Button>
                          }
                        />
                      ) : (
                        <Button
                          style={{ width: 'auto', marginBottom: 10 }}
                          color="rgb(45, 168, 136)"
                          appearance="primary"
                          onClick={handleSubmit(handleOnConfirmSendApprove)}
                          icon={<Icon appearance="ghost" icon="edit" />}
                          disabled={isLoading || disabledForm}
                        >
                          {SAVE}
                        </Button>
                      )}
                    </Row>
                  )
                )}
                {/* {console.log('555=>',formSchema?.projectData?.values[0]?.id)} */}

                <Row>
                  {formSchema?.projectData?.checkButton && (
                    <ApproverList
                      approveType={12}
                      projectversionId={formSchema?.projectData?.values[0]?.id}
                      style={{ marginLeft: 10 }}
                      buttontext={formSchema?.projectData?.checkButton}
                      workPlanCode={workPlanCodeVal}
                      budget={budgetVal}
                      isLoading={isLoading}
                      fetchButton={(disabled) =>
                        formSchema?.projectData?.fetchButton && (
                          <FetchNewApprover
                            approveType={12}
                            projectversionId={formSchema?.projectData?.values[0]?.id}
                            style={{ marginRight: 10, marginBottom: 10 }}
                            buttontext={formSchema?.projectData?.fetchButton}
                            onSuccess={onButtonSuccess}
                            requestId={formSchema?.projectData?.values[0]?.projectPaymentReviewerId}
                            disabled={disabled}
                          />
                        )
                      }
                    />
                  )}
                  {formSchema?.projectData?.cancelButton && (
                    <CancelApprovalList
                      approveType={12}
                      projectversionId={formSchema?.projectData?.values[0]?.id}
                      style={{ marginRight: 10, marginLeft: 10 }}
                      buttontext={formSchema?.projectData?.cancelButton}
                      onSuccess={onButtonSuccess}
                      requestId={formSchema?.projectData?.values[0]?.projectPaymentReviewerId}
                    />
                  )}
                </Row>

                <br />
                <Row>
                  <Button
                    style={{ width: 'auto' }}
                    appearance="ghost"
                    onClick={() => {
                      onCancelShowTable()
                    }}
                    icon={<Icon appearance="chevron-circle-up" />}
                    disabled={isLoading}
                  >
                    <Icon icon="chevron-circle-up" />
                    {'  เลือกผู้ทรงคุณวุฒิใหม่'}
                  </Button>
                </Row>
              </Col>
            </Row>
          </Grid>
        </Panel>
      )}
      <ConfirmWidget
        title={
          CONFIRM_MSG + (isAlreadyWithdraw ? SAVE : formSchema?.projectData?.sendApproveButtonText)
        }
        show={isShowConfirmSendApprove}
        detail={
          PLEASE_CONFIRM_MSG +
          (isAlreadyWithdraw ? SAVE : formSchema?.projectData?.sendApproveButtonText)
        }
        onCancle={() => setIsShowConfirmSendApprove(false)}
        onConfirm={handleCallApiSendApprove}
      />
      <ConfirmWidget
        title={CONFIRM_MSG + formSchema?.projectData?.approveButtonText}
        show={isShowConfirmApprove}
        detail={PLEASE_CONFIRM_MSG + formSchema?.projectData?.approveButtonText}
        onCancle={() => setIsShowConfirmApprove(false)}
        onConfirm={handleCallApiApprove}
      />
      <ConfirmWidget
        title={CONFIRM_MSG + formSchema?.projectData?.notApproveButtonText}
        show={isShowConfirmNotApprove}
        detail={PLEASE_CONFIRM_MSG + formSchema?.projectData?.notApproveButtonText}
        onCancle={() => setIsShowConfirmNotApprove(false)}
        onConfirm={handleCallApiApprove}
      />
      <ConfirmWidget
        title={CONFIRM_MSG + SAVE_DRAFT_MSG}
        show={isShowConfirmSaveDraft}
        detail={PLEASE_CONFIRM_MSG + SAVE_DRAFT_MSG}
        onCancle={() => setIsShowConfirmSaveDraft(false)}
        onConfirm={handleCallApiSaveDraft}
      />

      {isLoading && !isError && <OverlayLoader />}
    </>
  )
}
